import State from 'store/State';
import { selectWidgetsState } from '../selectors';

export const selectWidgetSharedState = (state: State) =>
    selectWidgetsState(state).shared;
